import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ArrowRight({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ArrowRight</title>
      <path
        d="M4 11.25C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75L4 11.25ZM20 12L20.5303 12.5303C20.8232 12.2374 20.8232 11.7626 20.5303 11.4697L20 12ZM13.4697 17.4697C13.1768 17.7626 13.1768 18.2374 13.4697 18.5303C13.7626 18.8232 14.2374 18.8232 14.5303 18.5303L13.4697 17.4697ZM14.5303 5.46967C14.2374 5.17678 13.7626 5.17678 13.4697 5.46967C13.1768 5.76256 13.1768 6.23744 13.4697 6.53033L14.5303 5.46967ZM4 12.75L20 12.75L20 11.25L4 11.25L4 12.75ZM19.4697 11.4697L13.4697 17.4697L14.5303 18.5303L20.5303 12.5303L19.4697 11.4697ZM20.5303 11.4697L14.5303 5.46967L13.4697 6.53033L19.4697 12.5303L20.5303 11.4697Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
